import React, { Component } from "react";
import Swiper from "react-id-swiper";
import { findIndex } from "lodash";
import DesignTool from "../../designtool";
import { SRC_IMAGE } from "../../constants";
import { CHARM_TYPE, RODEO_TYPE, MAX_WIDTH_SP } from "../../const";

export default class MaterialsTray extends Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: JSON.parse(localStorage.getItem("materials")) || []
    };
    this.loadingTray = false;
    this.timer = () => {};
  }

  componentWildMount() {
    // disable longpess save image
    window.oncontextmenu = event => {
      event.preventDefault();
      event.stopPropagation();

      return false;
    };
  }

  componentDidUpdate() {
    let { isUpdateMaterialsTray, handleUpdateState, productList } = this.props;
    let stones = document.querySelectorAll(".stone-list img");
    let materials = this.state.materials || [];
    let srcImage = SRC_IMAGE.replace(/^https:\/\//i, "http://");
    [].forEach.call(stones, function(img) {
      let tmp = materials.find(function(o) {
        return o.sizes.id == img.id;
      });
      let index = findIndex(productList, item => item.id === tmp.id);
      let hookPos = null;

      if (index !== -1 && tmp.type === CHARM_TYPE) {
        hookPos = {
          hookW: productList[index].charm_hanger_width,
          hookX: productList[index].charm_hanger_coord_x,
          hookY: productList[index].charm_hanger_coord_y
        };
      }

      var item = DesignTool.createItem(
        tmp.sizes.id,
        srcImage + tmp.image,
        img.naturalWidth,
        tmp.sizes.size,
        tmp.id,
        tmp.type,
        hookPos
      );
      item.img = img;
      DesignTool.registerDrag(item);
    });

    if (isUpdateMaterialsTray) {
      this.loadMaterials();
      handleUpdateState("isUpdateMaterialsTray", false);

      // show element remove material
      setTimeout(() => {
        let delay;
        let elmContainer = document.getElementById("main-content");
        let listItems = document
          .getElementsByClassName("stone-list")[0]
          .getElementsByTagName("img");
        let listItem;
        // Set number of milliseconds for longpress
        let longpress = 0;

        if (listItems) {
          for (var i = 0, j = listItems.length; i < j; i++) {
            listItem = listItems[i];

            listItem.addEventListener(
              "mousedown",
              function() {
                delay = setTimeout(check, longpress);
                function check() {
                  elmContainer.classList.add("remove_material");
                }
              },
              true
            );

            listItem.addEventListener("mouseup", function(e) {
              // On mouse up, we know it is no longer a longpress
              elmContainer.classList.remove("remove_material");
              clearTimeout(delay);
            });

            listItem.addEventListener("mouseout", function(e) {
              elmContainer.classList.remove("remove_material");
              clearTimeout(delay);
            });
          }
        }
      }, 300);
    }
  }

  loadMaterials() {
    let materials = JSON.parse(localStorage.getItem("materials")) || [];
    this.setState({
      materials: materials
    });
  }

  handleRenderStyle(material) {
    if (material.sizes.size > 20) {
      return (material.sizes.size / 100 + 36) * 2;
    }

    return (material.sizes.size + 16) * 2;
  }

  handleGetHeight() {
    let heightWin = window.innerHeight;

    return heightWin - 288;
  }

  renderItem(material) {
    let { getWidthBrowser } = this.props;
    let srcImage = SRC_IMAGE.replace(/^https:\/\//i, "http://");
    let imageH =
      getWidthBrowser() >= MAX_WIDTH_SP
        ? this.handleRenderStyle(material)
        : getWidthBrowser() >= 768 && window.orientation === 0
        ? this.handleRenderStyle(material) / 1.2
        : this.handleRenderStyle(material) / 2;
    let imageW = (material.objSize.width * imageH) / material.objSize.height;

    return (
      <div className="stone-item">
        <div
          className={`material_img stone-image 
                    ${material.type === CHARM_TYPE ? "image-charm" : ""}`}
        >
          <img
            crossOrigin="anonymous"
            src={srcImage + material.image + `?t=${new Date().getTime()}`}
            alt=""
            id={material.sizes.id}
            style={{ padding: `calc((100% - ${imageW}px) / 2)` }}
            draggable="true"
            onDragStart={e => this.onDrag(e)}
            onTouchStart={e => this.onTouchStart(e)}
            onTouchEnd={e => this.onTouchEnd(e)}
            onTouchMove={e => this.onTouchMove(e)}
          />
        </div>
        <div className="material_content">
          <h4>{material.name}</h4>
          <span>{material.sizes.size + "mm"}</span>
        </div>
      </div>
    );
  }

  onDrag(ev) {
    ev.dataTransfer.setData("materialId", ev.target.id);
  }

  onDragOver(ev) {
    ev.preventDefault();
  }

  onDrop(ev) {
    ev.preventDefault();
    let { handleUpdateState } = this.props;
    let id = ev.dataTransfer.getData("materialId");
    let elmContainer = document.getElementById("main-content");
    let listMaterial = JSON.parse(localStorage.getItem("materials")) || [];
    let tmpList = [...listMaterial];

    // Remove material in tray
    listMaterial.map((item, index) => {
      if (item.sizes.id === parseInt(id)) {
        tmpList.splice(index, 1);
      }
    });

    this.loadingTray = true;
    elmContainer.classList.remove("remove_material");
    localStorage.setItem("materials", JSON.stringify([]));
    handleUpdateState("isUpdateMaterialsTray", true);

    setTimeout(() => {
      this.loadingTray = false;
      localStorage.setItem("materials", JSON.stringify(tmpList));
      handleUpdateState("isUpdateMaterialsTray", true);
    }, 300);
  }

  onTouchStart(ev) {
    let elmContainer = document.getElementById("main-content");
    let imgMove = document.getElementById("img_move");
    // Set number of milliseconds for longpress
    let longpress = 0;

    window.oncontextmenu = event => {
      event.preventDefault();
      event.stopPropagation();

      return false;
    };

    // set image and position
    imgMove.src = ev.target.currentSrc;
    imgMove.style.visibility = "hidden";
    imgMove.parentElement.style.top = `${ev.changedTouches[0].pageY}px`;
    imgMove.parentElement.style.left = `${ev.changedTouches[0].pageX}px`;

    this.timer = setTimeout(() => {
      elmContainer.classList.add("remove_material");
    }, longpress);
  }

  onTouchMove(ev) {
    let imgMove = document.getElementById("img_move");
    let drawToolArea = document.getElementById("draw_tool_parent");
    let footerArea = document.getElementById("footer_sp");

    imgMove.parentElement.style.top = `${ev.changedTouches[0].pageY}px`;
    imgMove.parentElement.style.left = `${ev.changedTouches[0].pageX}px`;

    if (
      ev.changedTouches[0].pageY <
        drawToolArea.offsetTop + drawToolArea.offsetHeight ||
      (ev.changedTouches[0].pageY >
        window.innerHeight - footerArea.offsetHeight &&
        window.innerHeight > ev.changedTouches[0].pageY)
    ) {
      imgMove.style.visibility = "visible";
    } else {
      imgMove.style.visibility = "hidden";
    }
  }

  onTouchEnd(ev) {
    let { handleUpdateState } = this.props;
    let elmContainer = document.getElementById("main-content");
    let touchCurrent = ev.changedTouches[0];
    let listMaterial = JSON.parse(localStorage.getItem("materials")) || [];
    let tmpList = [...listMaterial];
    let elmRemoveMaterialH = 48; //48px height
    let imgMove = document.getElementById("img_move");

    // remove image
    imgMove.src = "";
    imgMove.style.visibility = "hidden";
    imgMove.parentElement.style.top = `-100px`;
    imgMove.parentElement.style.left = `-100px`;

    if (window.innerWidth >= 768) {
      elmRemoveMaterialH = 66;
    }

    if (
      touchCurrent.pageX > 0 &&
      touchCurrent.pageX < window.innerWidth &&
      touchCurrent.pageY > window.innerHeight - elmRemoveMaterialH &&
      touchCurrent.pageY < window.innerHeight
    ) {
      // Remove material in tray
      listMaterial.map((item, index) => {
        if (item.sizes.id === parseInt(touchCurrent.target.id)) {
          tmpList.splice(index, 1);
        }
      });

      this.loadingTray = true;
      localStorage.setItem("materials", JSON.stringify([]));
      handleUpdateState("isUpdateMaterialsTray", true);

      setTimeout(() => {
        this.loadingTray = false;
        localStorage.setItem("materials", JSON.stringify(tmpList));
        handleUpdateState("isUpdateMaterialsTray", true);
      }, 300);
    }

    elmContainer.classList.remove("remove_material");
    if (this.timer) clearTimeout(this.timer);
  }

  render() {
    let { getWidthBrowser } = this.props;
    let materials = this.state.materials || [];
    let params = {
      loadMinimal: true,
      loadMinimalSize: 0,
      slidesPerView: 3,
      spaceBetween: 10,
      loop: false,
      key: materials.length,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    };

    if (getWidthBrowser() >= MAX_WIDTH_SP) {
      return (
        <div
          className={`main_sidebar ${
            this.loadingTray ? "loading_sidebar" : ""
          }`}
        >
          <h3> 素材ボックス</h3>
          <div className="material_tray scroll_bar_style">
            <ul className="stone-list">
              {materials.map((material, i) => (
                <li key={i}>{this.renderItem(material)}</li>
              ))}
            </ul>
          </div>
          <div
            className="delete_material"
            id="delete_material"
            onDrop={e => this.onDrop(e)}
            onDragOver={e => this.onDragOver(e)}
          >
            <span>
              <img src="/img/delete.png" alt="" />
            </span>
            素材ボックスから削除
          </div>
        </div>
      );
    }

    return (
      <div
        className={`main_sidebar ${this.loadingTray ? "loading_sidebar" : ""}`}
      >
        <div className="material_tray">
          <ul
            className={`stone-list ${
              materials.length > 3 ? "" : "hidden_arrow"
            }`}
          >
            <Swiper {...params}>
              {materials.map((material, i) => (
                <div key={i}>{this.renderItem(material)}</div>
              ))}
            </Swiper>
          </ul>
        </div>
        <div className="delete_material" id="delete_material">
          <span>
            <img src="/img/delete.png" alt="" />
          </span>
          素材ボックスから削除
        </div>
      </div>
    );
  }
}
